import React from 'react';

import { useTranslation } from '@common/hooks/translation';

import './style.scss';

const ErrorNotFoundPage = () => {
  const t = useTranslation('');

  return (
    <div className="error-404-m">
      <h1>404</h1>
      <p>{t('Page not found')}</p>
      <div className="animation-error">
        <div className="error-icon-b" />
      </div>
    </div>
  );
};

export default ErrorNotFoundPage;
